<section id="header" class="header mainHead">
  <div class="heading gold" style="color: #d7be69; padding-bottom: 13px">{{communityPassport ? 'Community Passport Profile' : 'My Passport Profile'}}</div>
</section>
<section id="basic-profile" fxLayout="column" class="flex-md-row basicProfile">
  <div *ngIf="profile.userImageUrl !== null" class="profileImage">
    <img class="image" src="{{ profile.userImageUrl }}" />
  </div>
  <div *ngIf="profile.userImageUrl === null" class="profileImage">
    <img class="image" src="{{apiURL}}images/MyProfile/user-icon-1 (4).png" />
  </div>

  <div class="content px-md-5 pt-md-0 pt-4">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="space-between" class="heading-section">
        <div class="heading">
          {{ profile.firstName }} {{ profile.lastName }} &nbsp;
          <img
            *ngIf="!communityPassport"
            src="assets/svg/pencil-alt-solid.svg"
            alt="alt"
            width="20px"
            height="20px"
            style="cursor: pointer"
            (click)="handleEditClick()"
          />
        </div>
        <button *ngIf="isDesktopDevice()" (click)="routeToProfile()" class="profile-button">Creatics Profile</button>
      </div>
      <div class="status">Status: {{ profile.status }}</div>
      <button *ngIf="!isDesktopDevice()" (click)="routeToProfile()"
        class="ms-auto me-auto mb-2 mt-0 profile-button-mobile justify-self-center">Creatics Profile</button>
      <div class="description">
        <strong>Bio: </strong>{{ profile.bio }}
      </div>
    </div>
  </div>
</section>
<section id="favourites" class="favouritesData">
  <div class="my-3 description" style="font-size: 11px;">Click on my Passport Stamps below to see my reviews of films and events. Tell me if you agree
    or not with an Upvote or Downvote. By doing this with my and other Passports, you will align
    yourself with community members that share your taste—and we can help each other discover
    and support great creative work!
  </div>
  <div class="favourites d-flex flex-row flex-wrap mb-4">
    <div class="favourite-card" *ngFor="let favourite of favouriteEvents" (click)="handleFavoriteEventBadgeClick(favourite)">
      {{ favourite.name }}
    </div>
  </div>
</section>
<div *ngIf="showEventDetails">
  <app-popup (closeEvent)="togglePopupState()"
    (popupInputSubmit)="handlePopupInputFormData($event)"
    #popup
    [eventType]="selectedEvent.eventType"
    [popupType]="popupType"
    [readonly]="communityPassport"
    [popupData]="selectedEvent"></app-popup>
</div>
